import { Component } from '@angular/core';

import { MouseMode } from '../../models/mouse-mode';
import { ITool } from '../../models/tool';
import { MouseModeService } from '../../services/mouse-state.service';

const ZOOM_TOOLS: ITool[] = [ {
    name: 'Click/drag to zoom - x',
    svgName: 'zoom-x',
    mouseMode: MouseMode.ZOOM_X
}, {
    name: 'Click/drag to zoom - xy',
    svgName: 'zoom-xy',
    mouseMode: MouseMode.ZOOM_XY
} ];

/** Component for showing metadata about the plot data */
@Component({
    selector: 'sci-zoom-tools',
    templateUrl: './tools.component.html',
    styleUrls: [ './annotations.component.scss' ]
})
export class ZoomToolsComponent  {
    tools = ZOOM_TOOLS;
    activeTool: ITool;

    constructor( private _mouseModeService: MouseModeService ) {
        this.activeTool = this.tools[0];
    }

    selectTool( tool: ITool ) {
        this.activeTool = tool;
        this._mouseModeService.setMouseMode( tool.mouseMode );
    }
}
